import React, { Component } from 'react';
import ArtWork from './ArtWork';

import './ArtOverview.scss';

class ArtOverview extends Component {

    counter = 0;
    // render pattern, (r)ight, (l)eft, (c)entered, '' is 3 images in grid
    renderArr = [
        'c', 'c', 'c',
        'x', 'x', 'x', 'x'
    ];
    offsetArr = [
        'offset-lg-0_5-l', '', '',
        '', '', '', '',
    ];
    // renderArr = [
    //     'r', 'r',
    //     'x', 'x', 'x',
    //     'c', 'c',
    //     'x', 'x', 'x',
    //     'l', 'l',
    //     'x', 'x', 'x'
    // ];
    // offsetArr = [
    //     'offset-lg-4-l', 'offset-lg-0',
    //     'offset-lg-0', 'offset-lg-0', 'offset-lg-0',
    //     'offset-lg-0-l', 'offset-lg-0-r',
    //     'offset-lg-0', 'offset-lg-0', 'offset-lg-0',
    //     'offset-lg-0', 'offset-lg-4-r',
    //     'offset-lg-0', 'offset-lg-0', 'offset-lg-0',
    //     'offset-lg-0-l', 'offset-lg-0-r',
    //     'offset-lg-0', 'offset-lg-0', 'offset-lg-0',
    // ];

    colClass(art, index) {
        let _template = <div className={"col-12 col-md-6 col-lg-3 " + this.offsetArr[this.counter]}
            // let _template = <div className={"col-12 col-md-6 col-lg-3"}
            data-counter={this.renderArr[this.counter]}
            data-index={index}
            key={index} >
            <ArtWork art={art} id={index} />
        </div>
        this.counter++;
        if (this.counter >= this.offsetArr.length) this.counter = 0;

        return _template;
    }

    render() {
        this.counter = 0;
        let artData = JSON.parse(this.props.array);
        return (
            <>
                <div className="row justify-content-center align-items-center">
                    {
                        artData.map((art, index) => {
                            if (index <= this.props.total) {
                                return (
                                    this.colClass(art, index)
                                )
                            }
                            else {
                                return '';
                            }
                        })
                    }
                </div>
            </>
        );
    }
}

export default ArtOverview;